'use strict'

import Map from 'assets/core/js/module/map'
import Modal from 'assets/core/js/module/modal'
import mapLoader from 'assets/themes/vacances-campings/js/module/mapLoader'

export default function (): Map | null | void {
  const modalEl = document.getElementById('modal-map-full')

  if (!modalEl) {
    return
  }

  const modal = new Modal(modalEl)

  let mapInitialized = false

  modal.element.addEventListener('modal.opened', () => {
    if (!mapElement) {
      return
    }
    mapElement.dispatchEvent(new CustomEvent('product.map.modal.opened'))
  })

  modal.element.addEventListener('modal.closed', () => {
    if (!mapElement) {
      return
    }
    mapElement.dispatchEvent(new CustomEvent('product.map.modal.closed'))
  })

  const mapElement = document.querySelector('#product-map .map')

  let map = null

  if (mapElement) {
    mapElement.addEventListener('click', function () {
      modal.setContent(document.getElementById('product-map-full') as HTMLElement)
      modal.open()

      if (!mapInitialized) {
        mapLoader()
          .then(() => {
            const markerEl = document.getElementById('product-map-marker')

            if (!markerEl) {
              return
            }

            map = new Map(
              '#product-map-full',
              {
                closeButton: true,
                onClose: function () {
                  modal.close()
                },
              },
              [
                {
                  id: 'product-map',
                  latitude: parseFloat(markerEl.getAttribute('data-latitude') as string),
                  longitude: parseFloat(markerEl.getAttribute('data-longitude') as string),
                },
              ]
            )

            mapInitialized = true
          })
          .catch(() => true)
      }
    })
  }

  return map
}
